<script>
	// libraries

	// components
	import ColumnChart from './components/ColumnChart.svelte'
	import Arrow from './components/Arrow.svelte'

	// other
	import { getChangeInPercent, formatDayShort, getWeekday } from './utils'

	import { dataAttacks, updateDateAttacks, lastDateAttacks } from './data'

	// data

	// ///////////////////////////////////////////////////////////
	// process data
	// ///////////////////////////////////////////////////////////

	const key = 'attacks'

	const dataLatest = dataAttacks.at(-1)[key]
	const dataLastWeek = dataAttacks.at(-2)[key]
	const dataChange = getChangeInPercent(dataLatest, dataLastWeek)

	const color = '#727272'

	const dateInvasion = new Date('2022-02-19') // this is between two of our weeks. real date: 2022-02-24

	const tooltipDateFct = (d) =>
		d
			? `${getWeekday(d.start_date)} <b>${formatDayShort(d.start_date)}</b> – ${getWeekday(d.end_date)} <b>${formatDayShort(d.end_date)}</b>`
			: ''
	const tooltipValueFct = (d) => (d ? d.attacks + ' Angriffe' : '')
</script>

<div class="attacks-chart">
	<div class="heading">
		<div class="main">So verändert sich die Zahl der Angriffe</div>
		<div class="subheading" style="color: #9b9b9b">
			<span style="color: {color}">{dataLatest}</span>
			<Arrow
				colorArrow="#fff"
				colorCircle={color}
				angle={dataChange}
				size={13} />
			letzte Woche,
			{dataLastWeek} in der Vorwoche
		</div>
	</div>

	<div class="spike-container">
		<ColumnChart
			{key}
			data={dataAttacks}
			{color}
			{tooltipDateFct}
			{tooltipValueFct}
			tooltipWidth={120}
			yTicks={[250, 500, 750, 1000]} />
	</div>

	<div class="caption">
		<b>Kampfhandlungen beider Seiten pro Woche</b>, Datenstand: {formatDayShort(
			lastDateAttacks
		)}, letzte Aktualisierung: {formatDayShort(updateDateAttacks)}

		Bereits vor dem russischen Einmarsch kam es in den Separatistengebieten zu
		Angriffen.

		<div class="attribution">
			Daten: <a href="https://acleddata.com/" target="_blank"
				>Armed Conflict Location &amp; Event Data Project</a>
		</div>
	</div>
</div>

<style lang="scss">
	@import 'main.scss';

	.attacks-chart {
		font-family: $ff-sans;
		font-size: 17px;
		line-height: 23px;
		font-weight: normal;
		color: #000;

		@media (max-width: 480px) {
			font-size: 16px;
			line-height: 22px;
		}
	}

	.spike-container {
		height: 170px;
		position: relative;
		margin-top: 20px;
	}

	.heading .main {
		font-family: $ff-serif;
		font-size: 22px;
		line-height: 30px;
		font-weight: bold;
		margin-bottom: 5px;

		@media (max-width: 480px) {
			font-size: 20px;
			line-height: 24px;
		}
	}

	.caption {
		color: #9b9b9b;
		margin-top: 20px;

		b {
			font-weight: 500;
		}
	}

	.subheading {
		font-weight: 600;
		margin: 0 0 20px 0;
	}

	.attribution {
		display: inline;

		a {
			text-decoration: underline !important;
			color: #9b9b9b !important;
			background: none !important;
			text-shadow: none !important;
		}
	}
</style>
